import { useApp } from "../../../../services/app-context";
import { getPerformanceColor } from "../../../../services/utils";

export function PerformanceCard({
  title,
  description,
  percentage,
  titleClassName,
}: {
  title: string;
  description: string;
  percentage: number;
  titleClassName?: string;
}) {
  const { tenantProfile } = useApp();
  const metric_ranges = tenantProfile?.metric_ranges || [];
  const color = getPerformanceColor(percentage, metric_ranges || []);
  return (
    <div
      className={`py-[27px] px-[22px] flex items-start gap-4 rounded-[10px]`}
      style={{ backgroundColor: color.progressBg }}
    >
      <span className={`text-xs capitalize w-[150px] ${titleClassName}`}>{title}</span>
      <div className="text-xs font-normal flex-1">{description}</div>
    </div>
  );
}
